module.exports = __webpack_public_path__ + "static/media/pic_familyplan.6abe2aa4.jpg";